import { axios }            from '../../../utils/axios';

import { observer, inject } from 'mobx-react';

import { Link }             from 'react-router-dom';
import React, { Component } from 'react';

import './Passport.css';

class Forgot extends Component<any, any> {
  constructor(props: any){
    super(props);

    this.state = {
      confirmPasswordError: "",
      returnedError: "",
      returnedSuccess: "",
    }

    this.doPasswordReset     = this.doPasswordReset.bind(this);
    this.confirmSamePassword = this.confirmSamePassword.bind(this);
  }

  doPasswordReset = (ev: React.FormEvent<HTMLFormElement>) => {
    var component: any = this;
    ev.preventDefault();

    component.setState({
      loading: true,
      confirmPasswordError: "",
      returnedSuccess: "",
      returnedError: ""
    });

    this.props.rootStore.profileStore.passwordReset(
      (component.refs.password as HTMLInputElement).value,
      (component.refs.confirm_password as HTMLInputElement).value,
      this.props.match.params.token,
      function(error: boolean, errorType: string, errorMessage: string) {
        console.log(error);
        if (error) {
          let errorState: any = {};
          errorState[errorType] = errorMessage
          component.setState(errorState);
          component.setState({
            loading: false,
          });
        } else {
          component.setState({
            loading: false,
            returnedSuccess: "Password successfully changed, please login."
          })
          setTimeout(() => {
            component.props.history.push('/login');
          }, 2000)
        }
      }
    );
  }

  confirmSamePassword() {
    var password = (this.refs.password as HTMLInputElement).value
    var confirm_password = (this.refs.confirm_password as HTMLInputElement).value
    if (password != confirm_password) {
      this.setState({
        confirmPasswordError: "Passwords do not match."
      });
    } else {
      this.setState({
        confirmPasswordError: ""
      });
    }
  }

  render() {
    var loader;

    var returnedError: JSX.Element = <div></div>;
    if (this.state.returnedError) {
      returnedError = (<div className="alert alert-warning" role="alert">
        <strong>Password Reset Error: </strong> {this.state.returnedError}
      </div>);
    }

    var returnedSuccess: JSX.Element = <div></div>;
    if (this.state.returnedSuccess) {
      returnedSuccess = (<div className="alert alert-warning" role="alert">
        <strong>Success: </strong> {this.state.returnedSuccess}
      </div>);
    }

    if (this.state.loading) {
      loader = <img src="/images/ajax-loader.gif" />;
    }

    return (
      <div className="Passport container-fluid">
      <div className="row">
        <div className="fixed-50 back hidden-xs">
          <img src="/images/blue-close-up-colorful-1333318.jpg" className="img-fluid" />
          <div className="fixed-image-caption">Photo by <a className="underlined" target="_blank" href="/https://www.pexels.com/@magda-ehlers-pexels?utm_content=attributionCopyText&utm_medium=referral&utm_source=pexels">Magda Ehlers</a> from <a className="underlined" target="_blank" href="/https://www.pexels.com/photo/red-and-multicolored-figure-1333320/?utm_content=attributionCopyText&utm_medium=referral&utm_source=pexels">Pexels</a></div>
        </div>
        <div className="fixed-50 fore form-half">
            <h1>Password Reset</h1>
            <br />
            <form onSubmit={this.doPasswordReset} action="/api/v1/forgot" method="post">
            <div className="form-group">
                <label>New Password</label>
                <input type="password" onChange={this.confirmSamePassword} className="form-control" name="password" ref="password" />
                <div className="form-warning text-danger"><b>{this.state.passwordError}</b></div>
            </div>
            <div className="form-group">
                <label>Confirm New Password</label>
                <input type="password" onChange={this.confirmSamePassword} className="form-control" name="password" ref="confirm_password" />
                <div className="form-warning text-danger"><b>{this.state.confirmPasswordError}</b></div>
            </div>
                <div className="form-group">
                  <button type="submit" className="btn btn-primary btn-lg">Forgot Password</button>
                  <span className="form-warning pull-right">{loader}</span>
                </div>
            </form>
            <div className="form-group">
              {returnedError}
              {returnedSuccess}
            </div>
            <hr />
            <p><Link to="/login">Login</Link></p>
            <p>Or go <Link to="/">home</Link>.</p>
        </div>
        </div>
      </div>
    );
  }
}

export default observer(Forgot);
